module.exports = __webpack_public_path__ + "img/across chest.bddb9c4f.png";